import React from 'react';
import { useTranslation } from 'react-i18next';
import usePublicStats from '../../hooks/usePublicStats';

const Features = () => {
  const { i18n } = useTranslation();
  const isKo = i18n.language === 'ko';
  // Q7 — the warning-letter figure is SERVER-COUNTED, never a literal.
  // This copy previously asserted "3,005 FDA Warning Letters"; nothing
  // counted that, and the real distinct-letter count is an order of
  // magnitude lower. When the count is unavailable the sentence drops the
  // quantity rather than guessing one.
  const { warningLetters, fmt } = usePublicStats();
  const wlKo = warningLetters != null
    ? `FDA Warning Letters ${fmt(warningLetters)}건 등 `
    : 'FDA Warning Letters 등 ';
  const wlEn = warningLetters != null
    ? `, including ${fmt(warningLetters)} FDA Warning Letters,`
    : ', including FDA Warning Letters,';

  const features = [
    {
      icon: 'AI',
      titleKo: 'AI 앙상블 검증 엔진',
      titleEn: 'AI Ensemble Validation Engine',
      descKo: `벡터 유사도 60% + 규칙 기반 30% + ML 분류기 10%의 3중 앙상블로 검증합니다. ${wlKo}지속적으로 업데이트되는 규제 데이터로 학습한 AI가 91.58% 정확도로 판단합니다.`,
      descEn: `VeriPass combines vector similarity, rule-based checks, and ML classification into a three-layer validation workflow. The system is trained on a continuously updated regulatory dataset${wlEn} and reaches 91.58% accuracy.`,
      badges: ['🤖 F1 91.58%', isKo ? '📊 지속 업데이트되는 학습 데이터' : '📊 Continuously updated training data']
    },
    {
      icon: 'ALT',
      titleKo: '시장별 맞춤 대체 표현',
      titleEn: 'Market-Specific Safe Alternatives',
      descKo: '각 시장 규제에 맞는 대체 표현을 자동으로 추천합니다. FDA, FTC Truth in Advertising 기준을 반영하여 안전한 표현을 제안합니다.',
      descEn: 'Automatically get safer wording tailored to each market. FDA and FTC advertising standards are reflected in the recommendation flow.'
    },
    {
      icon: 'UPD',
      titleKo: '규제 업데이트 모니터링',
      titleEn: 'Regulatory Update Monitoring',
      descKo: 'FDA·FTC 등 미국 규제 기관의 변경사항을 주 단위로 추적하여 검증 데이터에 반영합니다.',
      descEn: 'We track FDA and FTC regulatory changes weekly and fold them into the validation dataset.'
    },
    {
      icon: 'HIS',
      titleKo: '검증 이력 관리',
      titleEn: 'Validation History Management',
      descKo: '시장별 검증 이력을 체계적으로 관리하고 비교합니다. 과거 검색 기록을 저장하여 팀원들과 공유할 수 있습니다.',
      descEn: 'Track validation results by market and keep historical checks organized for your team.'
    }
  ];

  return (
    <section id="features" style={{ padding: '72px 0' }}>
      <div className="wrap">
        <div className="section-head">
          <h2>{isKo ? 'VeriPass의 핵심 기능으로' : 'Use VeriPass core features to'}</h2>
          <h3>{isKo ? '글로벌 시장 진출을 안전하게 준비하세요' : 'launch globally with confidence'}</h3>
        </div>
        <div className="grid-2">
          {features.map((f, i) => (
            <div key={i} className="card feature-card">
              <div className="icon-circle">{f.icon}</div>
              <h4>{isKo ? f.titleKo : f.titleEn}</h4>
              <p>{isKo ? f.descKo : f.descEn}</p>
              {f.badges && (
                <div className="badge-row">
                  {f.badges.map((b, j) => (
                    <span key={j} className="mini-badge">{b}</span>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
